import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  IconButton,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Image, Row } from "react-bootstrap";
import SVG from "react-inlinesvg";
//import SlidingComponent from "../../../../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import Media from "react-media";
import { connect } from "react-redux";
import Alert from "react-s-alert";
import * as yup from "yup";
import {
  get_admin_chain_added_templates,
  get_admin_global_added_templates,
} from "../../../../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import {
  add_new_choice_template_vendor,
  add_new_template_vendor,
  get_vendor_added_templates,
  all_get_vendor_added_templates,
  update_item_menu_setup,
} from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import SlidingComponent from "../../../../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import { ReusableOnboardingButton } from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";
import CustomizationItem from "./CustomizationItem";

const validate = (values) => {
  const errors = {};
  if (values.nutritional_info && !values.calories) {
    errors.calories = "Please enter calories";
  }

  if (values.allergy_info && values.allergies.length === 0) {
    errors.allergies = "Please select allergies";
  }

  if (values.one_size === false) {
    if (values.price === "") {
      errors.price = "Please enter price";
    }
  }

  if (values.one_size) {
    if (values.multipleSize && values.multipleSize.length === 0) {
      errors.multipleSize = "Please enter multiple size values";
    }
  }

  return errors;
};

const Customization = (props) => {
  const back = () => {
    if (props?.nutrition_information) {
      props.onChange(7);
    } else {
      props.onChange(6);
    }

    window.scroll(0, 0);
  };
  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    if (
      props.menuCategoryItems.currentState !== 9 ||
      props.menuCategoryItems.runingTrack !== 9
    ) {
      formData.currentState = 6;
      formData.runingTrack = 7;
    }

    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  const onSuccess = () => {
    props.onChange(9);
    window.scroll(0, 0);
  };
  const [showAddChoice, setShowAddChoice] = useState(false);
  const handleAddChoice = (templateId, data) => {
    if (templateId) {
      setTemplateId(templateId);
      formik.setFieldValue("name", data?.name);
      formik.setFieldValue("sizeOption", data?.sizeOption);
      formik.setFieldValue("mandatory_item", data?.mandatory_item);
      formik.setFieldValue("single_select", data?.single_select);
      formik.setFieldValue(
        "allow_adding_multiple",
        data?.allow_adding_multiple
      );
      formik.setFieldValue("active", data?.active);
      formik.setFieldValue("available", data?.available);
      formik.setFieldValue("save_as_template", data?.save_as_template);
    } else {
      formik.resetForm();
      setTemplateId("");
    }
    setShowAddChoice(true);
  };
  const handleCloseAddChoice = () => setShowAddChoice(false);
  const [showCustomizedTemplates, setShowCustomizedTemplates] = useState(false);
  const handleCustomizedTemplates = () => setShowCustomizedTemplates(true);
  const handleCloseCustomizedTemplates = () =>
    setShowCustomizedTemplates(false);
  const [showAddOptionItem, setShowAddOptionItem] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [itemId, setItemId] = useState("");

  const [addTemplateError, setTemplateError] = useState("");

  /********************************
   * @DESC Simple OnClick Action
   ********************************/
  const handleAddOptionItemSimple = (templateId, itemId, itemData) => {
    setTemplateId(templateId);
    if (itemId) {
      setItemId(itemId);
      formikAddOptions.setFieldValue("name", itemData?.name);
      formikAddOptions.setFieldValue("one_size", itemData?.one_size);
      formikAddOptions.setFieldValue("multipleSize", itemData?.multipleSize);
      formikAddOptions.setFieldValue("price", itemData?.price);
      formikAddOptions.setFieldValue("veg", itemData?.veg);
      formikAddOptions.setFieldValue("food_type", itemData?.food_type);
      formikAddOptions.setFieldValue(
        "nutritional_info",
        itemData.nutritional_info
      );
      formikAddOptions.setFieldValue("calories", itemData?.calories);
      formikAddOptions.setFieldValue("allergy_info", itemData?.allergy_info);
      formikAddOptions.setFieldValue("allergies", itemData?.allergies);
    } else {
      setItemId("");
      //formikAddOptions.setFieldValue("allergies", []);
      formikAddOptions.resetForm();
    }
    setShowCustomizedTemplates(false);
    setShowAddOptionItem(true);
  };

  const handleAddOptionItem = (templateId, itemId, itemData) => {
    if (findSizeOption !== formik.values.sizeOption) {
      let error =
        "Size option does not match this template, please select diffrent template or change size option";
      setTemplateError(error);
    } else {
      setTemplateId(templateId);
      if (itemId) {
        setItemId(itemId);
        formikAddOptions.setFieldValue("name", itemData?.name);
        formikAddOptions.setFieldValue("one_size", itemData?.one_size);
        formikAddOptions.setFieldValue("multipleSize", itemData?.multipleSize);
        formikAddOptions.setFieldValue("price", itemData?.price);
        formikAddOptions.setFieldValue("veg", itemData?.veg);
        formikAddOptions.setFieldValue("food_type", itemData?.food_type);
        formikAddOptions.setFieldValue(
          "nutritional_info",
          itemData?.nutritional_info
        );
        formikAddOptions.setFieldValue("calories", itemData?.calories);
        formikAddOptions.setFieldValue("allergy_info", itemData?.allergy_info);
        formikAddOptions.setFieldValue("allergies", itemData?.allergies);
      } else {
        setItemId("");
        //formikAddOptions.setFieldValue("allergies", []);
        formikAddOptions.resetForm();
      }
      setShowCustomizedTemplates(false);
      setShowAddOptionItem(true);
    }
  };

  const handleCloseAddOptionItem = () => setShowAddOptionItem(false);

  const [state, setState] = useState([{ SelectTemplate: "" }]);

  const [activeCatalogName, setActiveCatalogName] = useState(1);
  const onChangeCatalogName = (id) => {
    setActiveCatalogName(id);
  };

  /*************************************
   * @DESC Action from Customizable?
   **************************************/
  const onChangeItemCustomize = () => {
    formikCutomizable.setFieldValue(
      "customizable",
      !formikCutomizable.values?.customizable
    );
  };

  const [showResetModel, setShowResetModel] = useState(false);
  const onhandleResetModel = () => {
    setShowResetModel(!showResetModel);
  };

  /*************************************************
   * @DESC Show Size Options popup
   ************************************************/
  const [showSizeOptionModel, setShowSizeOptionModel] = useState(false);
  const handleOpenSizeOptionModal = () => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    props.get_vendor_added_templates(vendorId, token);
    props.all_get_vendor_added_templates(vendorId, token);
    formik.setFieldValue("sizeOption", "");
    formikAssignTemplate.resetForm();
    setShowSizeOptionModel(true);
  };
  const handleCloseSizeOptionModal = () => {
    setShowSizeOptionModel(false);
  };

  /*************************************
   * @DESC Action from Same Add Onn
   **************************************/
  const onChangeItemSameAddOn = () => {
    if (formikCutomizable.values.sameAddOn) {
      formikCutomizable.setFieldValue("sameAddOn", false);
      formikCutomizable.setFieldValue("diffrentAddon", true);
    } else {
      formikCutomizable.setFieldValue("sameAddOn", true);
      formikCutomizable.setFieldValue("diffrentAddon", false);
    }
    if (formikCutomizable.values.addOns.length <= 0) {
      onhandleResetModel();
    } else {
      const token = props.auth.user.accessToken;
      let blankArray = [];
      let formData = {};
      formData = { ...formikCutomizable.values };
      formData.addOns = blankArray;
      formData.sameAddOn = false;
      formData.diffrentAddon = true;
      props.update_item_menu_setup(props.activeItemId, formData, token, () =>
        onSuccessToggle("SameAddOn")
      );
    }
  };
  /*************************************
   * @DESC Action from Diffrent Add Onn
   **************************************/
  const onChangeItemDiffrentAddon = () => {
    if (formikCutomizable.values.diffrentAddon) {
      formikCutomizable.setFieldValue("diffrentAddon", false);
      formikCutomizable.setFieldValue("sameAddOn", true);
    } else {
      formikCutomizable.setFieldValue("diffrentAddon", true);
      formikCutomizable.setFieldValue("sameAddOn", false);
    }
    if (formikCutomizable.values.addOns.length <= 0) {
      onhandleResetModel();
    } else {
      const token = props.auth.user.accessToken;
      let blankArray = [];
      let formData = {};
      formData = { ...formikCutomizable.values };
      formData.addOns = blankArray;
      formData.sameAddOn = true;
      formData.diffrentAddon = false;
      props.update_item_menu_setup(props.activeItemId, formData, token, () =>
        onSuccessToggle("diffrent")
      );
    }
  };

  const onSuccessToggle = (value) => {
    onhandleResetModel();
  };

  const onSuccessAddChoice = (msg) => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    props.get_vendor_added_templates(vendorId, token);
    formikAddOptions.resetForm();
    formikAssignTemplate.resetForm();
    setShowAddChoice(false);
    setShowAddOptionItem(false);
    setAssignTemplateId("");
    setActiveAssignTemplate(false);
    Alert.success(`<h4>${msg}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const onChangeMandtory = (status) => {
    formik.setFieldValue("mandatory_item", status);
  };

  const onChangeSizeOption = (status) => {
    formik.setFieldValue("sizeOption", status);
  };

  const onChangeSingleSelect = (status) => {
    formik.setFieldValue("single_select", status);
  };

  const formikCutomizable = useFormik({
    initialValues: {
      customizable: false,
      sameAddOn: true,
      diffrentAddon: false,
      addOns: [],
    },

    onSubmit: (values) => {
      //props.onChange(9);
      let formData = {};
      formData = { ...formikCutomizable.values };
      const token = props.auth.user.accessToken;
      if (
        props.menuCategoryItems.currentState !== 9 ||
        props.menuCategoryItems.runingTrack !== 9
      ) {
        formData.currentState = 8;
        formData.runingTrack = 9;
      }

      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onClickAddNewChoice = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      sizeOption: "",
      mandatory_item: false,
      single_select: false,
      allow_adding_multiple: false,
      save_as_template: false,
      active: false,
      available: false,
      freeOptions: 0,
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(256, "Must be 256 characters or less")
        .required("Please enter name"),
      freeOptions: yup.number(),
    }),
    onSubmit: (values) => {
      let msg = "Template Added sucessfully";
      //props.onChange(9);
      const token = props.auth.user.accessToken;
      let formData = {};
      formData = { ...values };
      if (templateId.length > 2) {
        let msg = "Template Edited sucessfully";
        props.add_new_choice_template_vendor(
          templateId,
          formData,
          token,
          onSuccessAddChoice,
          msg,
          onUpdateFormik
        );
      } else {
        props.add_new_template_vendor(
          formData,
          token,
          onSuccessAddChoice,
          msg,
          onUpdateFormik
        );
        //window.scroll(0, 0);
      }
    },
  });

  const onUpdateFormikDelete = (id) => {
    let tempData = formikCutomizable.values.addOns.filter((item) => {
      return id !== item._id;
    });
    formikCutomizable.setFieldValue("addOns", tempData);

    let formData = {};
    formData.addOns = tempData;
    const token = props.auth.user.accessToken;
    props.update_item_menu_setup(props.activeItemId, formData, token);
  };

  const onUpdateFormikDeleteItem = (id, data) => {
    let tempData = formikCutomizable.values.addOns;
    let updateData = [];
    for (let i = 0; i < tempData.length; i++) {
      if (id === tempData[i]._id) {
        updateData.push(data); // edit data
      } else {
        updateData.push(tempData[i]); // existing  data
      }
    }
    formikCutomizable.setFieldValue("addOns", updateData);
    // as we are updating and deleting so changes should be directly reflected to menu data
    let formData = {};
    formData.addOns = updateData;
    const token = props.auth.user.accessToken;
    props.update_item_menu_setup(props.activeItemId, formData, token);
  };

  const onUpdateFormik = (data) => {
    let edit = false;
    let tempData = formikCutomizable.values.addOns;
    let updateData = [];
    if (tempData.length >= 1) {
      for (let i = 0; i < tempData.length; i++) {
        if (data._id === tempData[i]._id) {
          edit = true;
          updateData.push(data); // edit data
        } else {
          updateData.push(tempData[i]); // existing  data
        }
      }
    }
    if (!edit) {
      updateData.push(data); // new data
    }

    formikCutomizable.setFieldValue("addOns", updateData);
    formikAddOptions.resetForm();
    formikAssignTemplate.resetForm();
  };

  const onChangeFoodType = (id) => {
    formikAddOptions.setFieldValue("food_type", id);
  };

  const onChangeSize = (status) => {
    let blankArr = [];
    if (status) {
      formikAddOptions.setFieldValue("price", "");
      formikAddOptions.setFieldValue("multipleSize", blankArr);
    } else {
      formikAddOptions.setFieldValue("price", "");
      formikAddOptions.setFieldValue("multipleSize", blankArr);
    }
    formikAddOptions.setFieldValue("one_size", status);
  };

  const onChangeVegNon = (status, value) => {
    formikAddOptions.setFieldValue("veg", status);
    formikAddOptions.setFieldValue("option_type", value);
  };

  const onChangeNutrutionalInfo = () => {
    formikAddOptions.setFieldValue(
      "nutritional_info",
      !formikAddOptions.values.nutritional_info
    );
  };

  const onChangeAllergyInfo = () => {
    formikAddOptions.setFieldValue(
      "allergy_info",
      !formikAddOptions.values?.allergy_info
    );
  };

  const onChangeAddRemoveAllergy = (titleName) => {
    let updateData = formikAddOptions.values.allergies;
    if (updateData.includes(titleName)) {
      let filterData = updateData.filter((item) => {
        return item !== titleName;
      });
      updateData = filterData;
    } else {
      updateData.push(titleName);
    }
    formikAddOptions.setFieldValue("allergies", updateData);
  };

  const onClickSave = (e) => {
    e.preventDefault();
    formikAddOptions.handleSubmit();
  };

  const formikAddOptions = useFormik({
    initialValues: {
      //item_customize: false,
      name: "",
      one_size: false,
      price: "",
      multipleSize: [],
      veg: true,
      option_type: 1,
      food_type: "",
      nutritional_info: false,
      calories: "",
      allergy_info: false,
      allergies: [],
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(64, "Must be 64 characters or less")
        .required("Please enter name"),
      price: yup.number(),
      // .required("Please enter price"),
      food_type: yup.string().required("Please select food type"),
    }),
    validate,

    onSubmit: (values) => {
      //props.onChange(9);
      let msg = "Item added sucessfully";
      let dataToAppend = props.vendor_templates;
      let alreadyAddOns = formikCutomizable.values.addOns;
      let mainTemplateId = activeAssignTemplate ? assignTemplateId : templateId;
      let optionsData = [];
      for (let i = 0; i < alreadyAddOns.length; i++) {
        if (alreadyAddOns[i]._id === mainTemplateId) {
          for (let j = 0; j < alreadyAddOns[i].options.length; j++) {
            optionsData.push(alreadyAddOns[i].options[j]);
          }
        }
      }

      // for (let i = 0; i < dataToAppend.length; i++) {
      //   if (
      //     dataToAppend[i]._id === activeAssignTemplate
      //       ? assignTemplateId
      //       : templateId
      //   ) {
      //     for (let j = 0; j < dataToAppend[i].options.length; j++) {
      //       optionsData.push(dataToAppend[i].options[j]);
      //     }
      //   }
      // }
      if (itemId) {
        // this is for edit
        let updateOptionData = optionsData.filter((item) => {
          return item._id !== itemId;
        });
        msg = "Item edited sucessfully";
        optionsData = updateOptionData;
      }
      optionsData.push(values);
      const token = props.auth.user.accessToken;
      let formData = {};
      formData.options = optionsData;
      props.add_new_choice_template_vendor(
        activeAssignTemplate ? assignTemplateId : templateId,
        formData,
        token,
        onSuccessAddChoice,
        msg,
        onUpdateFormik
      );

      // window.scroll(0, 0);
    },
  });

  const [assignTemplateId, setAssignTemplateId] = useState("");
  const [activeAssignTemplate, setActiveAssignTemplate] = useState(false);
  const [findSizeOption, setFindSizeOption] = useState("");
  const onChangeLoadOptionData = (e) => {
    setTemplateError("");
    let id = e.target.value;
    let data = formikAssignTemplate.values.savedTemplates.filter((data) => {
      if (data._id === id) {
        return data;
      }
    });
    let finalData = data && data[0];
    setFindSizeOption(finalData.sizeOption);
    formikAssignTemplate.setFieldValue("selectedTemplatedId", id);
    formikAssignTemplate.setFieldValue(
      "selectedTemplatedSizeOption",
      finalData?.sizeOption
    );
    setAssignTemplateId(id && id);
    setActiveAssignTemplate(true);
    setTemplateId(id);
    let actualData = formikAssignTemplate.values.savedTemplates;
    for (let i = 0; i < actualData.length; i++) {
      if (actualData[i]._id === id) {
        formikAssignTemplate.setFieldValue("options", actualData?.[i]?.options);
        break;
      }
    }
  };

  const onChangeLoadChainData = (e) => {
    let id = e.target.value;
    formikAssignTemplate.setFieldValue("selectedChainTemplateId", id);
    setAssignTemplateId(id && id);
    setActiveAssignTemplate(true);
    setTemplateId(id);
    let actualData = formikAssignTemplate.values.chainCatalogs;
    for (let i = 0; i < actualData.length; i++) {
      if (actualData[i]._id === id) {
        formikAssignTemplate.setFieldValue(
          "chainOptions",
          actualData?.[i]?.options
        );
        break;
      }
    }
  };

  const onChangeLoadGlobalData = (e) => {
    let id = e.target.value;
    formikAssignTemplate.setFieldValue("selectedGlobalTemplateId", id);
    setAssignTemplateId(id && id);
    setActiveAssignTemplate(true);
    setTemplateId(id);
    let actualData = formikAssignTemplate.values.globalCatalogs;
    for (let i = 0; i < actualData.length; i++) {
      if (actualData[i]._id === id) {
        formikAssignTemplate.setFieldValue(
          "globalOptions",
          actualData?.[i]?.options
        );
        break;
      }
    }
  };

  const addRemoveCheck = (id, status) => {
    let tempOptionsData = formikAssignTemplate.values.options;
    let updatedValueStatus = [];

    for (let i = 0; i < tempOptionsData.length; i++) {
      if (tempOptionsData[i]._id === id) {
        let changeStatus = tempOptionsData[i];
        changeStatus.value = !status;
        updatedValueStatus.push(changeStatus);
      } else {
        updatedValueStatus.push(tempOptionsData[i]);
      }
    }

    let actualData = formikAssignTemplate.values.savedTemplates;
    let updateActualSavedData = [];
    for (let i = 0; i < actualData.length; i++) {
      if (
        actualData[i]._id === formikAssignTemplate.values.selectedTemplatedId
      ) {
        let tempData = actualData[i];
        tempData.options = updatedValueStatus;
        updateActualSavedData.push(tempData);
      } else {
        updateActualSavedData.push(actualData[i]);
      }
    }
    //selectedTemplatedId
    formikAssignTemplate.setFieldValue("options", updatedValueStatus);
    formikAssignTemplate.setFieldValue("savedTemplates", updateActualSavedData);
  };

  const addRemoveCheckOptions = (id, status) => {
    let tempOptionsData = formikAssignTemplate.values.chainOptions;
    let updatedValueStatus = [];

    for (let i = 0; i < tempOptionsData.length; i++) {
      if (tempOptionsData[i]._id === id) {
        let changeStatus = tempOptionsData[i];
        changeStatus.value = !status;
        updatedValueStatus.push(changeStatus);
      } else {
        updatedValueStatus.push(tempOptionsData[i]);
      }
    }

    let actualData = formikAssignTemplate.values.chainCatalogs;
    let updateActualSavedData = [];
    for (let i = 0; i < actualData.length; i++) {
      if (
        actualData[i]._id ===
        formikAssignTemplate.values.selectedChainTemplateId
      ) {
        let tempData = actualData[i];
        tempData.options = updatedValueStatus;
        updateActualSavedData.push(tempData);
      } else {
        updateActualSavedData.push(actualData[i]);
      }
    }
    //selectedTemplatedId
    formikAssignTemplate.setFieldValue("chainOptions", updatedValueStatus);
    formikAssignTemplate.setFieldValue("chainCatalogs", updateActualSavedData);
  };

  const addRemoveCheckOptionsGlobal = (id, status) => {
    let tempOptionsData = formikAssignTemplate.values.globalOptions;
    let updatedValueStatus = [];

    for (let i = 0; i < tempOptionsData.length; i++) {
      if (tempOptionsData[i]._id === id) {
        let changeStatus = tempOptionsData[i];
        changeStatus.value = !status;
        updatedValueStatus.push(changeStatus);
      } else {
        updatedValueStatus.push(tempOptionsData[i]);
      }
    }

    let actualData = formikAssignTemplate.values.globalCatalogs;
    let updateActualSavedData = [];
    for (let i = 0; i < actualData.length; i++) {
      if (
        actualData[i]._id ===
        formikAssignTemplate.values.selectedGlobalTemplateId
      ) {
        let tempData = actualData[i];
        tempData.options = updatedValueStatus;
        updateActualSavedData.push(tempData);
      } else {
        updateActualSavedData.push(actualData[i]);
      }
    }
    //selectedTemplatedId
    formikAssignTemplate.setFieldValue("globalOptions", updatedValueStatus);
    formikAssignTemplate.setFieldValue("globalCatalogs", updateActualSavedData);
  };

  const onClickDone = (e) => {
    e.preventDefault();
    formikAssignTemplate.handleSubmit();
  };

  const formikAssignTemplate = useFormik({
    initialValues: {
      savedTemplates: [],
      options: [],
      selectedTemplatedId: "",
      selectedTemplatedSizeOption: "",
      chainCatalogs: [],
      chainOptions: [],
      selectedChainTemplateId: "",
      globalCatalogs: [],
      globalOptions: [],
      selectedGlobalTemplateId: "",
    },

    onSubmit: (values) => {
      let getOptionData = [];
      for (let i = 0; i < values.savedTemplates.length; i++) {
        if (values.savedTemplates[i]._id === values.selectedTemplatedId) {
          let getOnlyTrueValues = values.savedTemplates[i].options.filter(
            (item) => {
              return item.value !== false;
            }
          );
          let templateData = values.savedTemplates[i];
          templateData.options = getOnlyTrueValues;
          templateData.save_as_template = false;
          templateData.sizeOption = formik.values?.sizeOption;
          getOptionData.push(templateData);
          break;
        }
      }

      let dataForAddOnInFormik = formikCutomizable.values.addOns;
      let updatedFormikData = [];
      let ifFound = false;

      for (let i = 0; i < dataForAddOnInFormik.length; i++) {
        if (
          getOptionData[0]._id === dataForAddOnInFormik[i]._id ||
          getOptionData[0].sizeOption === dataForAddOnInFormik[i].sizeOption
        ) {
          updatedFormikData.push(getOptionData[0]);
          ifFound = true;
        } else {
          updatedFormikData.push(dataForAddOnInFormik[i]);
        }
      }

      // if (!ifFound) {
      //   if (getOptionData[0] === undefined) {
      //   } else {
      //     updatedFormikData.push(getOptionData[0]);
      //   }
      // }

      if (!ifFound) {
        updatedFormikData.push(getOptionData[0]);
      }

      // for chain
      let chainCheckedData = [];
      for (
        let i = 0;
        i < formikAssignTemplate.values.chainCatalogs.length;
        i++
      ) {
        let localId = [];

        let localFormikData = {
          ...formikAssignTemplate.values.chainCatalogs[i],
        };
        localFormikData.options = [];
        for (
          let j = 0;
          j < formikAssignTemplate.values.chainCatalogs[i].options.length;
          j++
        ) {
          if (formikAssignTemplate.values.chainCatalogs[i].options[j].value) {
            if (
              localId.includes(formikAssignTemplate.values.chainCatalogs[i]._id)
            ) {
              localFormikData.options.push(
                formikAssignTemplate.values.chainCatalogs[i].options[j]
              );
            } else {
              localId.push(formikAssignTemplate.values.chainCatalogs[i]._id);

              localFormikData.options.push(
                formikAssignTemplate.values.chainCatalogs[i].options[j]
              );
            }
          }
        }
        if (localFormikData.options.length > 0) {
          chainCheckedData.push(localFormikData);
        }
      }

      let existingChainId = [];
      for (let i = 0; i < chainCheckedData.length; i++) {
        existingChainId.push(chainCheckedData[i]._id);
      }

      // for global
      let globalCheckedData = [];
      for (
        let i = 0;
        i < formikAssignTemplate.values.globalCatalogs.length;
        i++
      ) {
        let localId = [];

        let localFormikData = {
          ...formikAssignTemplate.values.globalCatalogs[i],
        };
        localFormikData.options = [];
        for (
          let j = 0;
          j < formikAssignTemplate.values.globalCatalogs[i].options.length;
          j++
        ) {
          if (formikAssignTemplate.values.globalCatalogs[i].options[j].value) {
            if (
              localId.includes(
                formikAssignTemplate.values.globalCatalogs[i]._id
              )
            ) {
              localFormikData.options.push(
                formikAssignTemplate.values.globalCatalogs[i].options[j]
              );
            } else {
              localId.push(formikAssignTemplate.values.globalCatalogs[i]._id);

              localFormikData.options.push(
                formikAssignTemplate.values.globalCatalogs[i].options[j]
              );
            }
          }
        }
        if (localFormikData.options.length > 0) {
          globalCheckedData.push(localFormikData);
        }
      }

      let existingGlobalId = [];
      for (let i = 0; i < globalCheckedData.length; i++) {
        existingGlobalId.push(globalCheckedData[i]._id);
      }

      // remove records from exisiting formik if found

      let newUpdatedChainFormik = updatedFormikData.filter((item) => {
        return (
          !existingChainId.includes(item._id) ||
          !existingGlobalId.includes(item._id)
        );
      });

      for (let i = 0; i < chainCheckedData.length; i++) {
        newUpdatedChainFormik.push(chainCheckedData[i]);
      }

      for (let i = 0; i < globalCheckedData.length; i++) {
        newUpdatedChainFormik.push(globalCheckedData[i]);
      }

      const token = props.auth.user.accessToken;
      if (formikCutomizable?.values?.addOns.length > 0) {
        let msg = "Template Added sucessfully";
        let formData = newUpdatedChainFormik?.[0];
        delete formData._id;
        delete formData.__v;
        delete formData.createdAt;
        delete formData.updatedAt;
        props.add_new_template_vendor(
          formData,
          token,
          onSuccessAddChoice,
          msg,
          onUpdateFormik
        );
      } else {
        formikCutomizable.setFieldValue("addOns", newUpdatedChainFormik);
      }

      formikAssignTemplate.setFieldValue("savedTemplates", []);
      formikAssignTemplate.setFieldValue("options", []);
      formikAssignTemplate.setFieldValue("selectedTemplatedId", "");
      formikAssignTemplate.setFieldValue("selectedTemplatedSizeOption", "");
      formikAssignTemplate.setFieldValue("selectedChainTemplateId", "");
      formikAssignTemplate.setFieldValue("chainCatalogs", []);
      formikAssignTemplate.setFieldValue("chainOptions", []);
      formikAssignTemplate.setFieldValue("selectedGlobalTemplateId", "");
      formikAssignTemplate.setFieldValue("globalCatalogs", []);
      formikAssignTemplate.setFieldValue("globalOptions", []);

      handleCloseCustomizedTemplates();
      // window.scroll(0, 0);
    },
  });

  const titleCase = (str, name) => {
    str = str.toLowerCase().split(" ");
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formik.setFieldValue(name, str.join(" "));
  };
  const titleCaseChoice = (str, name) => {
    str = str.toLowerCase().split(" ");
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formikAddOptions.setFieldValue(name, str.join(" "));
  };

  // const [data, setData] = useState([]);

  // useEffect(() => {
  //   setData(props.vendor_templates);
  // }, [props.vendor_templates]);

  const onClickAssignTemplate = (e) => {
    e.preventDefault();
    handleCloseSizeOptionModal();
    let data = JSON.parse(JSON.stringify(props.all_vendor_templates));

    let chainCatalogs = [...props.chainTemplates];
    let globalCatalogs = [...props.globalTemplates];

    let showSavedTemplatesOnly = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].save_as_template) {
        let addValueInOptions = data[i];
        let updatedOptionWithValues = [];
        for (let j = 0; j < addValueInOptions.options.length; j++) {
          let tempValue = addValueInOptions.options[j];
          tempValue.value = false;
          updatedOptionWithValues.push(tempValue);
        }
        addValueInOptions.options = updatedOptionWithValues;
        showSavedTemplatesOnly.push(addValueInOptions);
      }
    }
    formikAssignTemplate.setFieldValue(
      "savedTemplates",
      showSavedTemplatesOnly
    );
    formikAssignTemplate.setFieldValue("chainCatalogs", chainCatalogs);
    formikAssignTemplate.setFieldValue("globalCatalogs", globalCatalogs);

    handleCustomizedTemplates();
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorId = props.auth.user.VendorUser._id;
    props.get_vendor_added_templates(vendorId, token);
    props.all_get_vendor_added_templates(vendorId, token);
  }, []);
  const [foodType, setFoodType] = useState([]);

  const [allergyInfo, setAllergyInfo] = useState([]);

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.food_type.length; i++) {
      if (props.food_type[i].status === "APPROVED") {
        data.push({
          _id: props.food_type[i]._id,
          title: props.food_type[i].title,
        });
      }
    }

    setFoodType(data);
  }, [props.food_type]);

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.allergy_info.length; i++) {
      if (props.allergy_info[i].status === "APPROVED") {
        data.push({
          title: props.allergy_info[i].title,
          icon: props.allergy_info[i].icon,
        });
      }
    }
    setAllergyInfo(data);
  }, [props.allergy_info]);

  const onClickNext = () => {
    formikCutomizable.handleSubmit();
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_admin_global_added_templates(token);
    props.get_admin_chain_added_templates(token);
  }, []);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      formikCutomizable.setFieldValue("customizable", data?.customizable);
      formikCutomizable.setFieldValue("sameAddOn", data?.sameAddOn);
      formikCutomizable.setFieldValue("diffrentAddon", data?.diffrentAddon);
      formikCutomizable.setFieldValue("addOns", data?.addOns);
      //formikCutomizable.setFieldValue("addOns", []);
    }
  }, [props.menuCategoryItems]);

  const formikAddMultipleSize = useFormik({
    initialValues: {
      sizeDescription: "",
      itemPrice: 0,
      calories: 0,
    },
    validationSchema: yup.object({
      sizeDescription: yup
        .string()
        .max(64, "Must be 64 characters or less")
        .required("Please enter description"),
      itemPrice: yup
        .number()
        .min(1, "minimum value 1")
        .max(10000, "Maximum value 10000")
        .required("Please enter price"),
      calories: yup
        .number()
        .min(1, "minimum value 1")
        .max(10000, "Maximum value 10000")
        .required("Please select Calories"),
    }),
    validate,

    onSubmit: (values) => {
      let formData = {};
      formData.sizeDescription = values.sizeDescription;
      formData.itemPrice = values.itemPrice;
      formData.calories = values.calories;
      let multipleSizeArr = formikAddOptions.values.multipleSize;
      if (isEdit) {
        formikAddOptions.setFieldValue(
          `multipleSize[${editData[0].id}]`,
          formData
        );
        setIsEdit(false);
        setEditData([]);
      } else {
        multipleSizeArr.push(formData);
        formikAddOptions.setFieldValue("multipleSize", multipleSizeArr);
      }
      formikAddMultipleSize.resetForm();
    },
  });

  const onClickAddNew = (e) => {
    e.preventDefault();
    formikAddMultipleSize.handleSubmit();
  };

  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);

  const onEditItem = (index, item) => {
    formikAddMultipleSize.setFieldValue(
      "sizeDescription",
      item?.sizeDescription
    );
    formikAddMultipleSize.setFieldValue("itemPrice", item?.itemPrice);
    formikAddMultipleSize.setFieldValue("calories", item?.calories);

    // formikCustom.setFieldValue("description", item.description);
    setIsEdit(true);
    setEditData([{ id: index }]);
    // handleCloseDetails();
  };

  const [deleteIndex, setDeleteIndex] = useState();
  const [showDeleteModal, onShowDeleteModal] = useState(false);

  const onClickDeleteIcon = (e, id) => {
    e.preventDefault();
    setDeleteIndex(id);
    onShowDeleteModal(true);
  };
  const handleDeleteModal = (e) => {
    e.preventDefault();

    let updateDeleted = formikAddOptions.values.multipleSize.filter(
      (item, index) => {
        return index !== deleteIndex;
      }
    );
    let foundDefault = true;
    let defaultData = updateDeleted;
    if (defaultData.length !== 0) {
      for (let i = 0; i < updateDeleted.length; i++) {
        if (updateDeleted.isDefault) {
          break;
        } else {
          foundDefault = false;
        }
      }
    }
    formikAddOptions.setFieldValue("multipleSize", defaultData);
    onShowDeleteModal(false);
  };
  const handleCloseDeleteModal = () => onShowDeleteModal(false);

  return (
    <React.Fragment>
      {/* {console.log("-----")}
      {console.log(props.vendor_templates)}
      {console.log("---END---")}
      {console.log("-----Formik-----")}
      {console.log(formikCutomizable.values.addOns)}
      {console.log("---Formik---END---")} */}
      <Form className="mobile-pb-70">
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={"w-100 bg-white"} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props?.menuCategoryItems &&
                      props?.menuCategoryItems?.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props?.menuCategoryItems && props?.menuCategoryItems.name}
        </div>
        <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Is Item Customizable?
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <ToggleButtonWithYesNo
              checkedBox={formikCutomizable?.values?.customizable}
              onChange={() => onChangeItemCustomize()}
            />
          </div>
        </div>
        {formikCutomizable?.values?.customizable ? (
          <>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
                Same add-on options for all item sizes
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formikCutomizable?.values?.sameAddOn}
                  onChange={() => onhandleResetModel()}
                />
              </div>
            </div>
            {formikCutomizable?.values?.sameAddOn ? (
              ""
            ) : (
              <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
                  Different add-on options for different item sizes
                </div>
                <div className="col-4 col-md-4 col-lg-6">
                  <ToggleButtonWithYesNo
                    checkedBox={formikCutomizable?.values?.diffrentAddon}
                    onChange={() => onhandleResetModel()}
                  />
                </div>
              </div>
            )}
          </>
        ) : null}

        <>
          {formikCutomizable?.values?.customizable ? (
            <>
              <div className="f14-700 mb-2">Choices & Addons</div>
              <div className="mb-4 f10-400 opacity5">
                You can select from the predefined templates to customize item
                or you can add new categories and customize items
              </div>
              <div className="d-flex flex-wrap align-items-center pb-4">
                <Button
                  variant="dark"
                  className="btn-md f13_400_HelveticaNeue"
                  onClick={() => handleAddChoice()}
                >
                  Add Choice
                </Button>
                <div className="f12-500 mx-3">Or</div>
                <button
                  type="button"
                  className={
                    "add-button-icon-reusable add-button-icon-reusable-blue"
                  }
                  onClick={
                    formikCutomizable?.values?.sameAddOn
                      ? (e) => onClickAssignTemplate(e)
                      : (e) => handleOpenSizeOptionModal()
                  }
                >
                  Assign Template
                </button>
              </div>

              {/* {formikCutomizable.values.addOns.map((item, index) => ( */}

              {/* {props.vendor_templates.map((item, index) => ( */}
              {formikCutomizable?.values?.addOns.map((item, index) => (
                <CustomizationItem
                  key={index}
                  data={item}
                  onUpdateFormikDeleteItem={(id, data) =>
                    onUpdateFormikDeleteItem(id, data)
                  }
                  onUpdateFormikDelete={(id) => onUpdateFormikDelete(id)}
                  onEditChoice={(id, data) => handleAddChoice(id, data)}
                  // onClick={(templateId, itemId, itemData) =>
                  //   handleAddOptionItem(templateId, itemId, itemData)
                  // }
                  onClick={(templateId, itemId, itemData) =>
                    handleAddOptionItemSimple(templateId, itemId, itemData)
                  }
                  style={{ marginBottom: "40px" }}
                />
              ))}
            </>
          ) : (
            <> </>
          )}
        </>

        {formikCutomizable?.values?.customizable ? (
          <>
            {formikCutomizable?.values?.sameAddOn ? (
              <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
                  Different add-on options for different item sizes
                </div>
                <div className="col-4 col-md-4 col-lg-6">
                  <ToggleButtonWithYesNo
                    checkedBox={formikCutomizable?.values?.diffrentAddon}
                    onChange={() => onhandleResetModel()}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        ) : null}

        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="btn-lg btn btn-outline-secondary"
            buttonText="Back"
            buttonType="button"
            onClick={() => onClickBack()}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
            buttonText="Save and Next"
            buttonType="button"
            //onClick={onSubmit}
            onClick={() => onClickNext()}
          />
        </div>
      </Form>
      <Modal
        show={showAddChoice}
        onHide={handleCloseAddChoice}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header className="px-lg-5 pt-lg-5 border-0" closeButton>
          <Modal.Title className="f18-700">
            Add-On Choice Name to Create a Template
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-lg-5 pb-lg-5">
          <Form>
            {formikCutomizable?.values?.diffrentAddon ? (
              <div>
                <p class="f14-500 mb-2">Size Option</p>
                <div className="d-flex align-items-center pb-4">
                  {props?.menuCategoryItems?.size.map((size, index) => {
                    return (
                      <React.Fragment key={index}>
                        <label className="enRadioWithText small mr-4">
                          <div className="f13-500">{size?.description}</div>
                          <input
                            type="radio"
                            name="sizeOption"
                            checked={
                              formik.values.sizeOption === size?.description
                                ? true
                                : false
                            }
                            onChange={() =>
                              onChangeSizeOption(size?.description)
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            ) : null}
            <div className="f16-700 pb-1">
              Add-On Choice Name to Create a Template and Reuse
            </div>
            <Row>
              <Col lg={10}>
                <NewInputText
                  controlClass={"name"}
                  labelText="e.g. Crust Base, Premium Toppings,"
                  extraClass={`mb-1 ${
                    formik.errors.name && formik.touched.name ? "enError" : ""
                  }`}
                  name="name"
                  //onChange={formik.handleChange}
                  onChange={(e) => titleCase(e.target.value, "name")}
                  value={formik.values.name}
                  onFocusOut={formik.handleBlur}
                />
                {/* <div className="f10-400">
                  e.g. Crust Base, Premium Toppings,
                </div> */}
                {formik.errors.name && formik.touched.name ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.name}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="pt-3">
              <Col md={6}>
                <div className="f16-700 pb-3">
                  Is item mandatory or optional?
                </div>
                <div className="d-flex align-items-center pb-4">
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Mandatory</div>
                    <input
                      type="radio"
                      name="mandatory_item"
                      checked={formik.values.mandatory_item === true}
                      onChange={() => onChangeMandtory(true)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Optional</div>
                    <input
                      type="radio"
                      name="mandatory_item"
                      checked={formik.values.mandatory_item === false}
                      onChange={() => onChangeMandtory(false)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="f16-700 pb-3">
                  Is this item Single Selection or Multi Selection?
                </div>
                <div className="d-flex align-items-center pb-4">
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Single Select</div>
                    <input
                      type="radio"
                      name="single_select"
                      checked={formik.values.single_select === true}
                      onChange={() => onChangeSingleSelect(true)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">Multi Select</div>
                    <input
                      type="radio"
                      name="single_select"
                      checked={formik.values.single_select === false}
                      onChange={() => onChangeSingleSelect(false)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </Col>
              <Col md={6}>
                <div className="d-flex row mb-3 pt-2">
                  <Col md={2} className="f12-700">
                    Active{" "}
                  </Col>
                  <Col xs={8} className="d-flex">
                    No &nbsp;
                    <SlidingComponent
                      name="status"
                      currentState={formik.values.active}
                      type={"checkbox"}
                      toggleclass={
                        "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                      }
                      toggleinputclass={
                        "toggle__switch vendor-super-admin-toggle"
                      }
                      onChange={() =>
                        formik.setFieldValue("active", !formik.values?.active)
                      }
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={formik.values.active}
                    />
                    &nbsp;Yes
                  </Col>
                </div>
                <div className="d-flex align-items-center row mb-3">
                  <Col xs={2} className="f12-700">
                    Available{" "}
                  </Col>
                  <Col xs={8} className="d-flex">
                    No &nbsp;
                    <SlidingComponent
                      name="status"
                      currentState={formik.values.available}
                      type={"checkbox"}
                      toggleclass={
                        "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                      }
                      toggleinputclass={
                        "toggle__switch vendor-super-admin-toggle"
                      }
                      onChange={() =>
                        formik.setFieldValue(
                          "available",
                          !formik.values?.available
                        )
                      }
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={formik.values?.available}
                    />
                    &nbsp;Yes
                  </Col>
                </div>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <div className="f16-700 pb-3">
                  Options added in the template are free until
                </div>
                <p className="f10-500 opacity5">
                  Select number upto which the add ons will be free and above
                  which they will be charged
                </p>
              </Col>
              <Col md={6}>
                <FormControl className="w-25" variant="outlined">
                  <InputLabel htmlFor="outlined-time">Select Number</InputLabel>
                  <Select
                    onChange={formik.handleChange}
                    value={formik.values.freeOptions}
                    label="Select Number"
                    inputProps={{
                      name: "freeOptions",
                      id: "outlined-time",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" selected>
                      Select Number
                    </MenuItem>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((data) => (
                      <MenuItem value={data}>{data}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
            </Row>

            <div className="d-flex align-items-center pb-3">
              <Form.Check
                label="1"
                inline
                className="enCheckBoxOnly d-grid"
                name="allow_adding_multiple"
                checked={formik.values.allow_adding_multiple}
                onChange={formik.handleChange}
              />
              <div className="f13-500">
                Allow adding same choice multiple times
              </div>
            </div>
            <div className="d-flex align-items-center pb-3">
              <Form.Check
                label="1"
                inline
                className="enCheckBoxOnly d-grid"
                name="save_as_template"
                checked={formik.values.save_as_template}
                onChange={formik.handleChange}
              />
              <div className="f13-500">Save as a template</div>
            </div>
            <div className="mobile-po-unset onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn150px btn btn-outline-secondary"
                buttonText="Cancel"
                buttonType="button"
                onClick={handleCloseAddChoice}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn150px btn btn-danger btn-lg ml-3 "
                buttonText="Save"
                buttonType="button"
                // onClick={handleCloseAddChoice}
                onClick={(e) => onClickAddNewChoice(e)}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showAddOptionItem}
        onHide={handleCloseAddOptionItem}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header className="px-lg-5 pt-lg-5 border-0" closeButton>
          <Modal.Title className="f18-700">Add On Option Item 1</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-lg-5 pb-lg-5 new-subscription-onboarding-component">
          <Form>
            <Row>
              <Col lg={10}>
                <NewInputText
                  controlClass={"nameA"}
                  labelText="Item Name"
                  extraClass={`mb-1 ${
                    formikAddOptions.errors.name &&
                    formikAddOptions.touched.name
                      ? "enError"
                      : ""
                  }`}
                  name="name"
                  //onChange={formikAddOptions.handleChange}
                  onChange={(e) => titleCaseChoice(e.target.value, "name")}
                  value={formikAddOptions.values.name}
                  onFocusOut={formikAddOptions.handleBlur}
                />
                {formikAddOptions.errors.name &&
                formikAddOptions.touched.name ? (
                  <div className="pho_14_regular text-danger mb-2">
                    {formikAddOptions.errors.name}
                  </div>
                ) : (
                  <div className="mb-2"></div>
                )}
              </Col>
            </Row>
            <div className="f16-700 pb-3">
              Is this Item Available in One Size or Multiple Sizes?
            </div>
            <div className="d-flex align-items-center pb-4">
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">One Size</div>
                <input
                  type="radio"
                  name="one_size"
                  checked={formikAddOptions.values.one_size === false}
                  onChange={() => onChangeSize(false)}
                />
                <span className="checkmark"></span>
              </label>
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">Multiple Size</div>
                <input
                  type="radio"
                  name="one_size"
                  checked={formikAddOptions.values.one_size === true}
                  onChange={() => onChangeSize(true)}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            {formikAddOptions?.values?.one_size === false ? (
              <Row>
                <Col lg={5} md={7}>
                  <h5 className="f16-500 mb-2">Item Price</h5>
                  <NewInputText
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputType="number"
                    controlClass={"price"}
                    labelText="Item Price"
                    extraClass={`mb-1 ${
                      formikAddOptions.errors.price &&
                      formikAddOptions.touched.price
                        ? "enError"
                        : ""
                    }`}
                    name="price"
                    onChange={formikAddOptions.handleChange}
                    value={formikAddOptions.values.price}
                    onFocusOut={formikAddOptions.handleBlur}
                  />
                  {formikAddOptions.errors.price &&
                  formikAddOptions.touched.price ? (
                    <div className="pho_14_regular text-danger mb-2">
                      {formikAddOptions.errors.price}
                    </div>
                  ) : (
                    <div className="mb-2"></div>
                  )}{" "}
                </Col>
              </Row>
            ) : (
              <Row>
                <Col lg={4} md={4}>
                  <h5 className="f16-500 mb-2">Size Description</h5>
                </Col>
                <Col lg={4} md={4}>
                  <h5 className="f16-500 mb-2">Item Price</h5>
                </Col>
                <Col lg={4} md={4}>
                  <h5 className="f16-500 mb-2">Calories</h5>
                </Col>
                <Col lg={4} md={4}>
                  <NewInputText
                    inputType="text"
                    controlClass={"sizeDescription"}
                    labelText="value"
                    extraClass={`mb-1 ${
                      formikAddMultipleSize.errors.sizeDescription &&
                      formikAddMultipleSize.touched.sizeDescription
                        ? "enError"
                        : ""
                    }`}
                    name="sizeDescription"
                    onChange={formikAddMultipleSize.handleChange}
                    value={formikAddMultipleSize.values.sizeDescription}
                    onFocusOut={formikAddMultipleSize.handleBlur}
                  />
                  {formikAddMultipleSize.errors.sizeDescription &&
                  formikAddMultipleSize.touched.sizeDescription ? (
                    <div className="pho_14_regular text-danger mb-2">
                      {formikAddMultipleSize.errors.sizeDescription}
                    </div>
                  ) : (
                    <div className="mb-2"></div>
                  )}{" "}
                </Col>
                <Col lg={4} md={4}>
                  <NewInputText
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputType="number"
                    controlClass={"itemPrice"}
                    labelText="value"
                    extraClass={`mb-1 ${
                      formikAddMultipleSize.errors.itemPrice &&
                      formikAddMultipleSize.touched.itemPrice
                        ? "enError"
                        : ""
                    }`}
                    name="itemPrice"
                    onChange={formikAddMultipleSize.handleChange}
                    value={formikAddMultipleSize.values.itemPrice}
                    onFocusOut={formikAddMultipleSize.handleBlur}
                  />
                  {formikAddMultipleSize.errors.itemPrice &&
                  formikAddMultipleSize.touched.itemPrice ? (
                    <div className="pho_14_regular text-danger mb-2">
                      {formikAddMultipleSize.errors.itemPrice}
                    </div>
                  ) : (
                    <div className="mb-2"></div>
                  )}{" "}
                </Col>
                <Col lg={4} md={4}>
                  <NewInputText
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputType="number"
                    controlClass={"calories"}
                    labelText="value"
                    extraClass={`mb-1 ${
                      formikAddMultipleSize.errors.calories &&
                      formikAddMultipleSize.touched.calories
                        ? "enError"
                        : ""
                    }`}
                    name="calories"
                    onChange={formikAddMultipleSize.handleChange}
                    value={formikAddMultipleSize.values.calories}
                    onFocusOut={formikAddMultipleSize.handleBlur}
                  />
                  {formikAddMultipleSize.errors.calories &&
                  formikAddMultipleSize.touched.calories ? (
                    <div className="pho_14_regular text-danger mb-2">
                      {formikAddMultipleSize.errors.calories}
                    </div>
                  ) : (
                    <div className="mb-2"></div>
                  )}{" "}
                </Col>
                {formikAddOptions.errors.multipleSize &&
                formikAddOptions.touched.multipleSize ? (
                  <div className="pho_14_regular text-danger mb-2">
                    {formikAddOptions.errors.multipleSize}
                  </div>
                ) : (
                  <div className="mb-2"></div>
                )}{" "}
                <Col lg={12} md={12} className="pb-4">
                  <AddButtonIconComponent
                    buttonText="Save and Add Another"
                    fontIcon="fa fa-plus"
                    colorCss="blue"
                    onClick={(e) => onClickAddNew(e)}
                  />
                </Col>
                {formikAddOptions?.values?.multipleSize !== null &&
                formikAddOptions?.values?.multipleSize !== undefined &&
                formikAddOptions?.values?.multipleSize.length > 0 ? (
                  <table className="enMinWidth900 w-100 table m-0">
                    <tr>
                      <td>
                        <div className="f12-500 pb-2">Size Description</div>
                      </td>
                      <td>
                        <div className="f12-500 pb-2">Item Price</div>
                      </td>
                      <td>
                        <div className="f12-500 pb-2">Calories</div>
                      </td>
                      <td>
                        <div className="f12-500 pb-2">Action</div>
                      </td>
                    </tr>
                    {formikAddOptions?.values?.multipleSize !== null &&
                      formikAddOptions?.values?.multipleSize !== undefined &&
                      formikAddOptions?.values?.multipleSize.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>
                              <div className="f11-500">
                                {item?.sizeDescription}
                              </div>
                            </td>
                            <td>
                              <div className="f11-500">{item?.itemPrice}</div>
                            </td>
                            <td>
                              <div className="f11-500">{item?.calories}</div>
                            </td>
                            <td>
                              <div className="d-flex align-itmes-center mt-2">
                                <IconButton className="mr-2 p-0">
                                  <Image
                                    src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                    alt="edit image"
                                    title="edit"
                                    className="w-20px"
                                    onClick={(e) => onEditItem(index, item)}
                                  />
                                </IconButton>
                                <IconButton className="p-0">
                                  <Image
                                    src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                    alt="delete image"
                                    title="delete item"
                                    className="w-20px"
                                    onClick={(e) => onClickDeleteIcon(e, index)}
                                  />
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                  </table>
                ) : null}
              </Row>
            )}
            <div className="f16-700 pb-3">Is this veg or Non Veg?</div>
            <div className="d-flex align-items-center pb-4">
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">Veg</div>
                <input
                  type="radio"
                  name="veg"
                  checked={formikAddOptions?.values?.option_type === 1}
                  onChange={() => onChangeVegNon(true, 1)}
                />
                <span className="checkmark"></span>
              </label>
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">Egg</div>
                <input
                  type="radio"
                  name="veg"
                  checked={formikAddOptions?.values?.option_type === 2}
                  onChange={() => onChangeVegNon(false, 2)}
                />
                <span className="checkmark"></span>
              </label>
              <label className="enRadioWithText small mr-4">
                <div className="f13-500">Non Veg/Others</div>
                <input
                  type="radio"
                  name="veg"
                  checked={formikAddOptions?.values?.option_type === 3}
                  onChange={() => onChangeVegNon(false, 3)}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="f16-700 pb-3">Food Type</div>
            <div className="mb-4 d-flex flex-wrap">
              {foodType.map((icon, index) => (
                <div
                  className="column4 enCheckWithText smallCenter"
                  key={index}
                >
                  <input
                    type="radio"
                    name="foodType"
                    checked={formikAddOptions.values.food_type === icon._id}
                    onChange={() => onChangeFoodType(icon._id)}
                  />
                  <label className="w-100 d-flex align-items-center justify-content-center">
                    {icon.title}
                  </label>
                </div>
              ))}
            </div>
            {formikAddOptions.errors.food_type &&
            formikAddOptions.touched.food_type ? (
              <div className="pho_14_regular text-danger">
                {formikAddOptions.errors.food_type}
              </div>
            ) : null}
            {formikAddOptions.values.one_size === false ? (
              <React.Fragment>
                {" "}
                <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
                  <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
                    Nutritional Information
                  </div>
                  <div className="col-4 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      checkedBox={formikAddOptions.values.nutritional_info}
                      onChange={() => onChangeNutrutionalInfo()}
                    />
                  </div>
                </div>
                {formikAddOptions.values.nutritional_info ? (
                  <Row>
                    <Col lg={5} md={7}>
                      <NewInputText
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        controlClass={"calories"}
                        labelText="Calories"
                        // extraClass="mb-1"
                        extraClass={`mb-1 ${
                          formikAddOptions.errors.calories &&
                          formikAddOptions.touched.calories
                            ? "enError"
                            : ""
                        }`}
                        name="calories"
                        onChange={formikAddOptions.handleChange}
                        value={formikAddOptions.values.calories}
                        onFocusOut={formikAddOptions.handleBlur}
                      />
                      {formikAddOptions.errors.calories &&
                      formikAddOptions.touched.calories ? (
                        <div className="pho_14_regular text-danger">
                          {formikAddOptions.errors.calories}
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                ) : (
                  <> </>
                )}
              </React.Fragment>
            ) : null}
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
                Allergy Information
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formikAddOptions.values.allergy_info}
                  onChange={() => onChangeAllergyInfo()}
                />
              </div>
            </div>
            {formikAddOptions.values.allergy_info ? (
              <>
                {allergyInfo.map((icon, index) => (
                  <div className="column4 enCheckWithText small" key={index}>
                    <input
                      type="checkbox"
                      name="allergyInformation"
                      checked={formikAddOptions.values.allergies.includes(
                        icon.title
                      )}
                      onChange={() => onChangeAddRemoveAllergy(icon.title)}
                    />
                    <label className="w-100 d-flex align-items-center">
                      <img width="20px" height="20px" src={icon.icon} />
                      <span className="pl-2">{icon.title}</span>
                    </label>
                  </div>
                ))}
              </>
            ) : (
              <> </>
            )}
            {formikAddOptions.errors.allergies &&
            formikAddOptions.touched.allergies ? (
              <div className="pho_14_regular text-danger">
                {formikAddOptions.errors.allergies}
              </div>
            ) : null}
            <div className="mobile-po-unset mobile-center onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn150px btn btn-outline-secondary"
                buttonText="Cancel"
                buttonType="button"
                onClick={handleCloseAddOptionItem}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn150px btn btn-danger btn-lg ml-3 "
                buttonText="Save"
                buttonType="button"
                //onClick={handleCloseAddOptionItem}
                onClick={(e) => onClickSave(e)}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showCustomizedTemplates}
        onHide={handleCloseCustomizedTemplates}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header className="px-lg-5 pt-lg-5 border-0" closeButton>
          <Modal.Title className="f18-700">Customized Templates 1</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-lg-5 pb-lg-5">
          <div
            className="d-flex f14-700 justify-content-between ml-md-5 mr-md-5"
            style={{ color: "rgba(0, 0, 0, 0.54)" }}
          >
            <div
              style={{
                color: activeCatalogName === 1 ? "#c82333" : "",
                borderBottom:
                  activeCatalogName === 1 ? "1px solid #c82333" : "",
                cursor: "pointer",
              }}
              onClick={() => setActiveCatalogName(1)}
            >
              My Templates
            </div>
            <div
              style={{
                color: activeCatalogName === 2 ? "#c82333" : "",
                borderBottom:
                  activeCatalogName === 2 ? "1px solid #c82333" : "",
                cursor: "pointer",
              }}
              onClick={() => setActiveCatalogName(2)}
            >
              Chain Templates
            </div>
            <div
              style={{
                color: activeCatalogName === 3 ? "#c82333" : "",
                borderBottom:
                  activeCatalogName === 3 ? "1px solid #c82333" : "",
                cursor: "pointer",
              }}
              onClick={() => setActiveCatalogName(3)}
            >
              Global Templates
            </div>
          </div>
          <hr />
          <Form>
            {/* <div className="f16-700 pb-1">Select Template</div> */}
            {activeCatalogName === 1 ? (
              <React.Fragment>
                <Row>
                  <Col lg={7}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-SelectTemplate">
                        Select Template
                      </InputLabel>
                      <Select
                        value={formikAssignTemplate.values.selectedTemplatedId}
                        //value={state.SelectTemplate}
                        label=" Select Template"
                        onChange={onChangeLoadOptionData}
                        inputProps={{
                          name: "SelectTemplate",
                          id: "outlined-SelectTemplate",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {formikAssignTemplate.values.savedTemplates.map(
                          (item, index) => (
                            <MenuItem key={index} value={item._id}>
                              {item.name}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>

                <Row>
                  {formikAssignTemplate.values.options?.map((item, index) => (
                    <Col lg={4} md={6} key={index}>
                      <div className="d-flex align-items-center pb-3">
                        <Form.Check
                          checked={item?.value}
                          label="1"
                          inline
                          className="enCheckBoxOnly d-grid"
                          onChange={() =>
                            addRemoveCheck(item?._id, item?.value)
                          }
                        />
                        <SVG
                          width="16px"
                          height="16px"
                          src={
                            item?.veg
                              ? require("../../../../../../../../assets/images/UserManagement/veg.svg")
                              : require("../../../../../../../../assets/images/UserManagement/nonveg.svg")
                          }
                        />
                        <div
                          className="f12-500 pl-2 text-break"
                          style={{ width: 125 }}
                        >
                          {item?.name}
                        </div>
                        {item?.price !== "" ? (
                          <input
                            // disabled
                            type="number"
                            placeholder="Value"
                            className="enPriceInput"
                            value={item?.price}
                          />
                        ) : null}
                      </div>
                      {item?.multipleSize?.map((insideValue, index) => {
                        return (
                          <div
                            className="row align-items-center mb-3"
                            key={index}
                          >
                            <div
                              className="col-4 f12-500 px-2 text-break"
                              style={{ width: 125 }}
                            >
                              {insideValue?.sizeDescription}
                            </div>
                            <div
                              className="col-4 f12-500 px-2 text-break d-flex align-items-center justify-content-between"
                              style={{ width: 125 }}
                            >
                              <input
                                disabled
                                type="number"
                                placeholder="Value"
                                className="w-75 enPriceInput"
                                // onChange={(e) => e}
                                name="calories"
                                value={insideValue?.calories}
                              />
                              <p className="f10-500">Cal</p>
                            </div>
                            <div className="col-4 f12-500 px-2 text-break d-flex align-items-center justify-content-between">
                              <input
                                disabled
                                type="number"
                                placeholder="Value"
                                className="w-75 enPriceInput"
                                // onChange={(e) => e}
                                name="rupees"
                                value={insideValue?.itemPrice}
                              />
                              <p className="f10-500">Rs.</p>
                            </div>
                          </div>
                        );
                      })}
                    </Col>
                  ))}
                </Row>
              </React.Fragment>
            ) : (
              <> </>
            )}
            {activeCatalogName === 2 ? (
              <React.Fragment>
                <Row>
                  <Col lg={7}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-SelectTemplate">
                        Select Template
                      </InputLabel>
                      <Select
                        value={
                          formikAssignTemplate.values.selectedChainTemplateId
                        }
                        //value={state.SelectTemplate}
                        label=" Select Template"
                        onChange={onChangeLoadChainData}
                        inputProps={{
                          name: "SelectTemplate",
                          id: "outlined-SelectTemplate",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {formikAssignTemplate.values.chainCatalogs.map(
                          (item, index) => (
                            <MenuItem key={index} value={item._id}>
                              {item.name}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  {formikAssignTemplate.values.chainOptions.map(
                    (item, index) => (
                      <Col lg={4} md={6} key={index}>
                        <div className="d-flex align-items-center pb-3">
                          <Form.Check
                            checked={item.value}
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            onChange={() =>
                              addRemoveCheckOptions(item._id, item.value)
                            }
                          />
                          <SVG
                            width="16px"
                            height="16px"
                            src={
                              item.veg
                                ? require("../../../../../../../../assets/images/UserManagement/veg.svg")
                                : require("../../../../../../../../assets/images/UserManagement/nonveg.svg")
                            }
                          />
                          <div
                            className="f12-500 pl-2 text-break"
                            style={{ width: 125 }}
                          >
                            {item.name}
                          </div>
                          <input
                            disabled
                            type="number"
                            placeholder="Value"
                            className="enPriceInput"
                            value={item.price}
                          />
                        </div>
                      </Col>
                    )
                  )}
                </Row>
              </React.Fragment>
            ) : (
              <> </>
            )}
            {activeCatalogName === 3 ? (
              <React.Fragment>
                <Row>
                  <Col lg={7}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-SelectTemplate">
                        Select Template
                      </InputLabel>
                      <Select
                        value={
                          formikAssignTemplate.values.selectedGlobalTemplateId
                        }
                        //value={state.SelectTemplate}
                        label=" Select Template"
                        onChange={onChangeLoadGlobalData}
                        inputProps={{
                          name: "SelectTemplate",
                          id: "outlined-SelectTemplate",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {formikAssignTemplate.values.globalCatalogs.map(
                          (item, index) => (
                            <MenuItem key={index} value={item._id}>
                              {item.name}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                <Row>
                  {formikAssignTemplate.values.globalOptions.map(
                    (item, index) => (
                      <Col lg={4} md={6} key={index}>
                        <div
                          className="d-flex align-items-center pb-3"
                          style={{ marginBottom: "40px" }}
                        >
                          <Form.Check
                            checked={item.value}
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            onChange={() =>
                              addRemoveCheckOptionsGlobal(item._id, item.value)
                            }
                          />
                          <SVG
                            width="16px"
                            height="16px"
                            src={
                              item.veg
                                ? require("../../../../../../../../assets/images/UserManagement/veg.svg")
                                : require("../../../../../../../../assets/images/UserManagement/nonveg.svg")
                            }
                          />
                          <div
                            className="f12-500 pl-2 text-break"
                            style={{ width: 125 }}
                          >
                            {item.name}
                          </div>
                          <input
                            disabled
                            type="number"
                            placeholder="Value"
                            className="enPriceInput"
                            value={item.price}
                          />
                        </div>
                      </Col>
                    )
                  )}
                </Row>
              </React.Fragment>
            ) : (
              <> </>
            )}
            <Media query="(max-width: 991px)">
              {formikAssignTemplate.values.selectedTemplatedId !== "" ? (
                <>
                  <AddButtonIconComponent
                    buttonText="Add Another Add On Option"
                    fontIcon="fa fa-plus"
                    colorCss="blue"
                    type={"button"}
                    onClick={handleAddOptionItem}
                  />
                  <p className="f11-500 mt-2" style={{ color: "#EE3A23" }}>
                    {addTemplateError}
                  </p>
                </>
              ) : null}
            </Media>
            <div className="mobile-po-unset mobile-center mt-5">
              <div className="row align-items-center">
                <div className="col-8 d-flex">
                  <ReusableOnboardingButton
                    buttonTitle="Back"
                    buttonClass="btn-lg btn150px btn btn-outline-secondary"
                    buttonText="Cancel"
                    buttonType="button"
                    onClick={handleCloseCustomizedTemplates}
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Done"
                    buttonClass="btn-lg btn150px btn btn-danger btn-lg ml-3 "
                    buttonText="Done"
                    buttonType="button"
                    //onClick={handleCloseCustomizedTemplates}
                    onClick={(e) => onClickDone(e)}
                  />
                </div>
                <div className="col-4">
                  <Media query="(min-width: 992px)">
                    {formikAssignTemplate.values?.selectedTemplatedId !== "" ? (
                      formikAssignTemplate.values
                        ?.selectedTemplatedSizeOption !==
                      formik.values?.sizeOption ? (
                        <></>
                      ) : (
                        <>
                          <AddButtonIconComponent
                            buttonText="Add Another Add On Option"
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                            type={"button"}
                            onClick={handleAddOptionItem}
                          />
                          <p
                            className="col-12 f10-500 mt-2"
                            style={{ color: "#EE3A23" }}
                          >
                            {addTemplateError}
                          </p>
                        </>
                      )
                    ) : null}
                  </Media>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/*************** Size Option Model ******************/}
      <Modal
        show={showSizeOptionModel}
        onHide={handleCloseSizeOptionModal}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="f24-700">Size Option</h4>
          <h4 className="f14-500">
            Please select size option for which you want to assign the
            customization template
          </h4>
          <div className="d-flex align-items-center pb-4 mt-5">
            {props?.menuCategoryItems?.size.map((size, index) => {
              return (
                <React.Fragment key={index}>
                  <label className="enRadioWithText small mr-4">
                    <div className="f13-500">{size?.description}</div>
                    <input
                      type="radio"
                      name="sizeOption"
                      checked={
                        formik.values.sizeOption === size?.description
                          ? true
                          : false
                      }
                      onChange={() => onChangeSizeOption(size?.description)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </React.Fragment>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseSizeOptionModal}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) => onClickAssignTemplate(e)}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        backdrop="static"
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete this item ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseDeleteModal}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) => handleDeleteModal(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showResetModel}
        onHide={onhandleResetModel}
        centered
        backdrop="static"
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          {formikCutomizable.values.addOns.length <= 0 ? (
            "Are you sure you want to change it?"
          ) : (
            <React.Fragment>
              {" "}
              Are you sure you want to change it? if yes <br />
              All the{" "}
              <span style={{ color: "#EE3A23" }}>
                {formikCutomizable.values.sameAddOn
                  ? "Same Add On"
                  : formikCutomizable.values.diffrentAddon
                  ? "Diffrent Add On"
                  : ""}
              </span>{" "}
              Option data will be deleted.
            </React.Fragment>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={onhandleResetModel}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) =>
              formikCutomizable.values.sameAddOn
                ? onChangeItemSameAddOn(e)
                : formikCutomizable.values.diffrentAddon
                ? onChangeItemDiffrentAddon(e)
                : ""
            }
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

Customization.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
  get_vendor_added_templates: PropTypes.func.isRequired,
  all_get_vendor_added_templates: PropTypes.func.isRequired,
  add_new_template_vendor: PropTypes.func.isRequired,
  add_new_choice_template_vendor: PropTypes.func.isRequired,
  get_admin_global_added_templates: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding && state.onboarding.activeItemId,
  vendor_templates: state.onboarding && state.onboarding.vendor_templates,
  all_vendor_templates:
    state.onboarding && state.onboarding.all_vendor_templates,
  food_type: state.category && state.category.foodtype,
  allergy_info: state.category && state.category.allergy_info,
  globalTemplates: state.commonSuperAdmin.admin_global_templates,
  chainTemplates: state.commonSuperAdmin.admin_chain_templates,
  nutrition_information:
    state.onboarding.restaurantDetails.nutrition_information,
});

export default connect(mapStateToProps, {
  update_item_menu_setup,
  get_vendor_added_templates,
  all_get_vendor_added_templates,
  add_new_template_vendor,
  add_new_choice_template_vendor,
  get_admin_global_added_templates,
  get_admin_chain_added_templates,
})(Customization);
